<script setup>
import DefaultButton from "@/components/onsiteEditor/components/buttons/DefaultButton.vue";
import {computed} from "vue";
import {useStore} from "vuex";
import VendastaWarningModal from "./modals/VendastaWarningModal.vue";
import AwaitingInstallation from "@/components/onsiteEditor/components/installation/modals/AwaitingInstallation.vue";
import OptimizerChecklist from "@/components/onsiteOptimizer/installation/partials/OptimizerChecklist.vue";
import useInstallation from "@/composables/optimizer/useOnsiteOptimizer";

const store = useStore();
const emit = defineEmits(['nextStep', 'goToAssisted']);
const user = computed(() => store.getters['user/user']);

const {
  beginInstallation,
  assistedInstallation,
  showInstallForMeButton,
  showAwaitingInstallationModal,
  showVendastaModal
} = useInstallation();
</script>

<template>
  <div
    v-if="user"
    class="tw-mb-25 tw-flex tw-flex-col tw-rounded-xl tw-bg-white tw-p-8"
  >
    <div class="tw-mb-5 tw-flex tw-text-2xl tw-font-bold tw-leading-8.5 tw-text-slate-100">
      Next Step: Enable SEO Changes on Your Website
    </div>
    <div class="tw-flex tw-flex-col">
      <div class="tw-flex tw-gap-10">
        <OptimizerChecklist class="tw-text-slate-200" />
        <div class="tw-flex tw-basis-1/2">
          <slot />
        </div>
      </div>
      <div class="tw-flex">
        <p>Please choose your installation method below, and let’s get started!</p>
      </div>
      <div class="tw-flex tw-gap-4">
        <DefaultButton
          class="tw-mt-5 !tw-w-[280px]"
          @click="beginInstallation(emit)"
        >
          I'll install the snippet myself
        </DefaultButton>
        <DefaultButton
          v-if="showInstallForMeButton"
          class="tw-mt-5 !tw-w-[280px]"
          variant="base"
          @click="assistedInstallation(emit)"
        >
          I want you to install it for me
        </DefaultButton>
      </div>
    </div>
  </div>

  <VendastaWarningModal
    v-if="showVendastaModal"
    @confirm="emit('nextStep')"
    @close="showVendastaModal = false"
  />

  <AwaitingInstallation
    v-if="showAwaitingInstallationModal"
    @confirm="emit('nextStep')"
    @close="showAwaitingInstallationModal = false"
  />
</template>
